module.exports = __webpack_public_path__ + "static/flask-5a29a3f7715fbed716b957fc5f9ed0f8.svg";